"use client";
import React, { useRef, useLayoutEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

type ActionButtonProps = {
  btnTxt: string;
  className?: string;
  onClick?: () => void;
};

const ActionButton = ({
  btnTxt,
  className = "",
  onClick,
}: ActionButtonProps) => {
  const btnRef = useRef<HTMLButtonElement>(null);
  const [btnWidth, setBtnWidth] = useState<number | null>(null);

  // Measure the button width initially so hover doesn’t change it
  useLayoutEffect(() => {
    if (btnRef.current) setBtnWidth(btnRef.current.offsetWidth);
  }, [btnTxt]);

  return (
    <Button
      ref={btnRef}
      style={btnWidth ? { width: `${btnWidth}px` } : {}}
      className={`xl:px-5 xl:py-3 px-4 py-2.5 h-auto! cursor-pointer font-archivo gap-2.5 text-base font-medium leading-6 rounded-[40px] bg-[linear-gradient(264deg,#0798F2_-29%,#43D9BD_85.45%)] hover:bg-[linear-gradient(264deg,#43D9BD_-29%,#0798F2_85.45%)] text-[#033D61] transition-all duration-75 hover:[&_svg]:-rotate-45 ${className}`}
      variant={"main"}
      onClick={onClick}
    >
      <span className="pl-4 group-hover:pl-0 transition-all duration-300 ease-in-out whitespace-nowrap text-center">
        {btnTxt}
      </span>
      <ArrowRight className="group-hover:hidden size-8! shrink-0 p-1 rounded-full bg-white text-primary! transition-all duration-300 ease-in-out" />
    </Button>
  );
};

export default ActionButton;
